import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';

import Header from 'components/Header';
import { Grid, Column } from 'components/Layout';
import { Button } from 'components/Button';

import thumbUp from 'assets/icons/thumbs-up.svg';
import style from './style.scss';

const Congrats = ({ history }) => {
  const applicationId = useSelector(state => get(state, 'workflow.entityId', get(state, 'workflow.attributes.entityId', '')));

  const handleButtonClick = (e) => {
    e.preventDefault();

    history.push('/dashboard');
  };

  return (
    <Fragment>
      <Header />
      <section className="container section">
        <div className={cn('grid-container fluid', style['borrowers-message'])}>
          <div className="grid-container">
            <Grid className="grid-margin-x max-limited">
              {applicationId ? (
                <div className="cell small-12 large-8 large-offset-2" style={{ textAlign: 'left', marginBottom: 20 }}>
                  <p className="mb-0 p-large"><b>Application ID:</b> {applicationId}</p>
                </div>
              ) : null}
              <Column className="small-12 large-8 large-offset-2">
                <img src={thumbUp} alt="congrats" />
                <h2>Thank you!<br />A link has been sent to your customer to complete their application!</h2>
                <p className="p-xlarge">Please check back later to see the status of the application</p>
                <Button
                  id="FormSubmit"
                  className="button large arrow green"
                  onClick={handleButtonClick}
                >
                  To Dashboard
                </Button>
              </Column>

            </Grid>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

Congrats.propTypes = {
  history: PropTypes.object.isRequired,
};

export default withRouter(Congrats);



// WEBPACK FOOTER //
// ./src/containers/pages/Congrats/index.js